import { render } from "./IconPlayCircleOutline.vue?vue&type=template&id=1922fb94"
import script from "./IconPlayCircleOutline.vue?vue&type=script&lang=js"
export * from "./IconPlayCircleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__